import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { FinalCausalityDataProps } from './props';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import {
    asyncGetLastCodeParam,
    asyncGetParams,
} from '../../../../../../services/param.service';
import { FinalCausality } from '../../../../../../shared/types/typifications/finalCausality';

export const useFinalCausalityData = ({
    data,
    onChangeData,
    onChangeFormik,
    finalCausalityId,
}: FinalCausalityDataProps) => {
    const [causalities, setCausalities] = useState<ISelect[]>([]);
    const [newCode, setNewCode] = useState<string>('');

    const onSubmit = (data: FinalCausality) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        const causalityName = data?.name || '';
        const [causeNumber, ...realCause] = causalityName.split(' - ');
        formik?.setFieldValue('code', newCode || '');
        formik?.setFieldValue(
            'finalCausality',
            (data?.parent as ISelect)?.id || ''
        );
        formik?.setFieldValue('causeNumber', causeNumber || '');
        formik?.setFieldValue('realCause', realCause.join(' - ') || '');
        formik?.setFieldValue('meaning', data?.extra || '');
        formik?.setFieldValue('description', data?.extra2 || '');
        formik?.setFieldValue('active', data?.active);
    }, [data, newCode]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_FINAL_CAUSALITY).then((items) =>
            setCausalities(items)
        );
    }, []);

    useEffect(() => {
        asyncGetLastCodeParam(ParamEnum.PQR_FINAL_CAUSALITY_MOTIVE).then(
            (res: any) => {
                setNewCode(res?.items);
            }
        );
    }, []);

    return {
        formik,
        causalities,
        finalCausalityId,
    };
};
